import React from 'react'
import {
  ExecuteOperationOnPipe,
  Form,
  Operation,
  TriggerPipelineOnFormSubmit,
  WhenModelValue
} from '@morningtrain/react-resources'
import StopEmploymentCancellationButton from 'pages/app/users/partials/StopEmploymentCancellationButton'
import { Pipeline } from '@morningtrain/react-helpers'
import { Fieldset } from 'layouts'

export default function StopEmploymentCancellationForm () {
  return (
          <Pipeline>
            <Operation namespace="api" resourceName="users" operationName="prevent_termination">
              <Form submitTo="prevent_termination" className="form-field">
                <Fieldset>
                  <WhenModelValue name="active">
                    <StopEmploymentCancellationButton/>
                  </WhenModelValue>
                </Fieldset>
                <TriggerPipelineOnFormSubmit/>
                <ExecuteOperationOnPipe resourceName="users.users" operationName="read"
                                        operationContext={{ context: 'user_profile' }}/>
              </Form>
            </Operation>
          </Pipeline>
  )
}
